// extracted by mini-css-extract-plugin
export default {"header":"header_header__p9Xsc","logoHeader":"header_logoHeader__WqHnc"};